export default class EventService {
  _protectedNames = ['LOCATION_CHANGED']

  constructor(rx) {
    'ngInject';
    Object.assign(this, {rx});

    this._subjects = {};
    this._subjectIds = {};
    

    this._actions = {
      AUTHENTICATE: { root: "template", name: "AUTHENTICATE" },
      CONTROL_LOADED: { root: "template", name: "CONTROL_LOADED" },
      CONFIG_TARGET_TABLE: { root: "template", name:  "CONFIG_TARGET_TABLE" },
      OPEN_DEFAULT_LINK_UPLOAD_CONFIG: { root: "template", name: "OPEN_DEFAULT_LINK_UPLOAD_CONFIG" },
      CONFIG_TOKEN: { root: "template", name:  "CONFIG_TOKEN" },
      DOWNLOAD_REPORT: { root: "template", name:  "DOWNLOAD_REPORT" },
      ELEMENT_STYLE_UPDATED: { root: "template", name: "ELEMENT_STYLE_UPDATED" },
      FIELD_INSERT: { root: "template", name: "FIELD_INSERT" },
      FIELD_UPDATED: { root: "template", name: "FIELD_UPDATED" },
      MODEL_UPDATED: { root: "template", name: "MODEL_UPDATED" },
      FOREIGN_KEY_CHANGED: { root: "template", name: "FOREIGN_KEY_CHANGED" },
      GOTO_PAGE: { root: "template", name: "GOTO_PAGE" },
      INTERNAL_ERROR: { root: "template", name: "INTERNAL_ERROR" },
      LOCATION_CHANGED: { root: "template", name: "LOCATION_CHANGED" },
      MOUSE_ENTERED_BUILD_HEADER: { root: "template", name: "MOUSE_ENTERED_BUILD_HEADER" },
      RECORDS_UPDATED: { root: "template", name: "RECORDS_UPDATED" },     
      REFERENCE_REMOVE_BEGIN: { root: "template", name: "REFERENCE_REMOVE_BEGIN" },
      REFERENCE_REMOVE_DONE: { root: "template", name: "REFERENCE_REMOVE_DONE" },
      REFERENCE_SELECT_BEGIN: { root: "template", name: "REFERENCE_SELECT_BEGIN" },
      REFERENCE_SELECT_DONE: { root: "template", name: "REFERENCE_SELECT_DONE" },
      RENDER_COMPLETE: { root: "template", name: "RENDER_COMPLETE" },
      REPORT_SELECTED: { root: "template", name: "REPORT_SELECTED" },
      RESTORE_TEMPLATE: { root: "template", name: "RESTORE_TEMPLATE" },
      SAVE_TEMPLATE: { root: "template", name: "SAVE_TEMPLATE" },
      TEMPLATE_DATA_UPDATED: { root: "template", name: "TEMPLATE_DATA_UPDATED" },
      TEMPLATE_DESTROY: { root: "template", name: "TEMPLATE_DESTROY" },
      TEMPLATE_VALIDATED: { root: "template", name: "TEMPLATE_VALIDATED" },
      TEMPLATE_ZOOM: { root: "template", name: "TEMPLATE_ZOOM" },
      TOKEN_GROUP_STYLE_SET: { root: "template", name: "TOKEN_GROUP_STYLE_SET" },
      TOKEN_REMOVE: { root: "template", name: "TOKEN_REMOVE" },
      TOKEN_SELECTED: { root: "template", name: "TOKEN_SELECTED" },
      TOKENS_DESELECTED: { root: "template", name:  "TOKENS_DESELECTED" },
      USER_MESSAGE_SELECTED: { root: "builder_menu", name:  "USER_MESSAGE_SELECTED" },
      TEMPLATE_CONTENT_UPDATED: { root: "builder_menu", name:  "TEMPLATE_CONTENT_UPDATED" },
      TEMPLATE_SWAP_PLACEHOLDER_TOKENS: { root: "builder_menu", name:  "TEMPLATE_SWAP_PLACEHOLDER_TOKENS" },
      
    };
  }

  get actions() {
    return this._actions;
  }
  
  get actionNames() {
    return Object.keys(this._actions);
  }

  subscribeEvent(action, callback, id) {
    const { name, root } = action;
    if (!this.validSubjectId(id)) {
      throw new Error(`subscriber id [${id}] must start with an Action Name`);
    }
    this._subjects[name] = this._subjects[name] || new this.rx.Subject();
    const sub = this._subjects[name].subscribe( payload => callback(payload) );

    if (id) {
      this._subjectIds[root]?.[id]?.dispose();
      this._subjectIds[root] = { ...this._subjectIds[root], [id]: sub };
    }

    return sub;
  }
  
  disposeSubscribers(root, actionNames=this.actionNames) {
    actionNames.forEach(name => {
      if (!this._subjects[name] || this._protectedNames.includes(name)) return;
      if (root && this._actions[name].root !== root) return;

      this._subjects[name].observers.forEach(o => o.dispose());
      this._subjects[name].dispose();
      delete this._subjects[name];
    });
    
    if (root) {
      Object.keys(this._subjectIds[root]).forEach(subId => {
        if (this.validSubjectId(subId, actionNames)) delete this._subjectIds[root][subId];
      });
    } else {
      this._subjectIds = {};
    }
  }
  
  validSubjectId(subId, nameList=this.actionNames) {
    return !subId || nameList.find(name => subId.startsWith(name));
  }

  dispatchEvent(action, payload) {
    const name = action.name;
    if (!this._subjects[name]) return;
    this._subjects[name].onNext(payload);
  }
}